<template>
  <div class="training-routes-table">
    <div class="row filters mb-4">
      <div class="col-xl-2 col-md-4 col-sm-6">
        <app-input
          @input="onInput"
          v-model="filters.client"
          placeholder="Nome ou CPF"
        ></app-input>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6">
        <app-input
          @input="onInput"
          v-model="filters.training"
          placeholder="Treinamento"
        ></app-input>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6">
        <b-field required>
          <b-datepicker
            @input="load"
            v-model="datesFilter"
            :years-range="[-100, 100]"
            :date-formatter="bDateRangeFormatter"
            placeholder="Filtrar por período"
            trap-focus
            range
          >
            <button
              @click="
                datesFilter = null;
                load();
              "
              v-app-button.icon-left.clear
            >
              <b-icon size="is-small" icon="close"></b-icon>Limpar
            </button>
          </b-datepicker>
        </b-field>
      </div>
    </div>

    <b-table
      :data="data"
      :loading="isLoading"
      paginated
      backend-pagination
      :total="total"
      :per-page="perPage"
      @page-change="onPageChange"
      aria-next-label="Próxima Página"
      aria-previous-label="Página Anterior"
      aria-page-label="Página"
      aria-current-label="Página Atual"
    >
      <template slot-scope="props">
        <b-table-column label="Nome">{{ props.row.name }}</b-table-column>
        <b-table-column label="CPF" centered>
          {{ props.row.cpf }}
        </b-table-column>
        <b-table-column label="Título" centered>
          {{ props.row.title }}
        </b-table-column>
        <b-table-column label="Última Tentativa" centered>
          {{ props.row.last_attempt | date('DD/MM/YYYY [às] HH:mm') }}
        </b-table-column>
        <b-table-column label="Tentativas" centered>
          {{ props.row.attempts }}
        </b-table-column>
        <b-table-column label="Pontos" centered>
          {{ props.row.points }}
        </b-table-column>
        <b-table-column label="Opções" centered>
          <router-link
            :to="`/clients/${props.row.client_id}/edit`"
            tag="button"
            type="button"
            v-app-button.icon-only
            v-tooltip.bottom="'Editar Usuário'"
          >
            <b-icon size="is-small" icon="pencil"></b-icon>
          </router-link>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
            </p>
            <p>Nenhum registro encontrado.</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import TrainingResponsesService from '@/services/training-responses.service';
import BuefyMixin from '@/mixins/BuefyMixin';

import { debounce } from 'lodash';

export default {
  name: 'training-reports-table',
  mixins: [BuefyMixin],
  data: () => {
    return {
      isLoading: true,
      datesFilter: null,
      filters: {
        client: null,
        training: null,
      },
      data: [],
      total: 0,
      page: 1,
      perPage: 10,
    };
  },
  computed: {
    requestFilters() {
      const { client, training } = this.filters;
      const [start_date, end_date] = this.datesFilter || [];

      return { client, training, start_date, end_date };
    },
  },
  methods: {
    load() {
      this.isLoading = true;

      TrainingResponsesService.get({
        page: this.page,
        perPage: this.perPage,
        ...this.requestFilters,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.total = total;
          this.data = data;
        })
        .catch(() =>
          this.toastify('Erro ao carregar Relatório de Treinamentos.', 'error')
        )
        .finally(() => (this.isLoading = false));
    },
    onInput: debounce(function () {
      this.load();
    }, 400),
    onPageChange(page) {
      (this.page = page), this.load();
    },
  },
  mounted() {
    if (localStorage.trainingsReportsTrainingr) {
      this.filters = {
        ...this.filters,
        training: localStorage.trainingsReportsTraining,
      };
    }

    if (localStorage.trainingsReportsClient) {
      this.filters = {
        ...this.filters,
        client: localStorage.trainingsReportsClient,
      };
    }

    if (localStorage.trainingsReportsTrainingDates) {
      const date = [
        new Date(localStorage.trainingsReportsTrainingDates.split(',')[0]),
        new Date(localStorage.trainingsReportsTrainingDates.split(',')[1]),
      ];
      this.datesFilter = date;
    }

    this.load();
  },
  watch: {
    datesFilter: (newValue) => {
      localStorage.trainingsReportsTrainingDates = newValue;
    },
    'filters.training': (newValue) => {
      localStorage.trainingsReportsTraining = newValue;
    },
    'filters.client': (newValue) => {
      localStorage.trainingsReportsClient = newValue;
    },
  },
};
</script>
